export {
  laysClassic,
  chocolateChipCookie,
  brownie,
  oatmealCookie,
  nutritionCalorieMapping,
  mediumFountainDrink,
} from './constants-shared';
